// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1NS_b","content":"styles_content__3R0tv","checkbox":"styles_checkbox__bWK6D","checkboxLabel":"styles_checkboxLabel__C0cof"};